var $bbc494a3111c1ee3$exports = {};
$bbc494a3111c1ee3$exports = {
    "valid": `Platn\xe9`
};


export {$bbc494a3111c1ee3$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
